import { Divider, NumberInput, Select, Switch, TextInput, Title } from '@mantine/core';
import { EditorItem, useEditorStore } from '../../store/editorStore';

type ImageItemPanelProps = {
  item: EditorItem;
  handleStyleUpdate: (styleUpdates: Partial<any>) => void;
};

export function ImageItemPanel({ item, handleStyleUpdate }: ImageItemPanelProps) {
  const updateItem = useEditorStore((state) => state.updateItem);
  
  return (
    <>
      <Title order={4}>Thuộc tính ảnh</Title>
      
      <Switch
        label="Xóa nền ảnh"
        checked={(item.style as any).removeBackground || false}
        onChange={(e) => handleStyleUpdate({ removeBackground: e.currentTarget.checked })}
      />
      
      <TextInput
        label="Màu nền (mã màu)"
        value={(item.style as any).backgroundColor || 'transparent'}
        onChange={(e) => handleStyleUpdate({ backgroundColor: e.target.value })}
        disabled={!((item.style as any).removeBackground || false)}
        placeholder="#RRGGBB, transparent hoặc tên màu"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      />
      
      <NumberInput
        label="Độ mờ (blur)"
        value={(item.style as any).blur || 0}
        onChange={(value) => handleStyleUpdate({ blur: value })}
        min={0}
        max={20}
        step={0.5}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      />
      
      <Select
        label="Kiểu hiển thị"
        value={(item.style as any).objectFit || 'contain'}
        onChange={(value) => handleStyleUpdate({ objectFit: value as string })}
        data={[
          { value: 'contain', label: 'Giữ tỷ lệ, hiện đầy đủ' },
          { value: 'cover', label: 'Bao phủ toàn bộ' },
          { value: 'fill', label: 'Kéo giãn vừa khung' }
        ]}
      />
      
      <Divider my="sm" label="Viền ô chứa" labelPosition="center" />
      
      <NumberInput
        label="Độ dày viền ô"
        value={(item.style as any).borderWidth || 0}
        onChange={(value) => handleStyleUpdate({ borderWidth: value })}
        min={0}
        max={20}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      />
      
      <TextInput
        label="Màu viền ô"
        value={(item.style as any).borderColor || '#000000'}
        onChange={(e) => handleStyleUpdate({ borderColor: e.target.value })}
        placeholder="#RRGGBB hoặc tên màu"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        disabled={(item.style as any).borderWidth <= 0}
      />
      
      <Divider my="md" />
      
      {/* Điều khiển lớp (zIndex) */}
      <NumberInput
        label="Lớp hiển thị (zIndex)"
        value={item.zIndex}
        onChange={(value) => {
          if (typeof value === 'number') {
            updateItem(item.id, { zIndex: value });
          }
        }}
        min={0}
        max={999}
        step={1}
        hideControls={false}
        allowDecimal={false}
        clampBehavior="strict"
        description="Giá trị càng cao, phần tử càng hiển thị phía trên"
      />
    </>
  );
} 